<template lang="pug">
section
  .hero.is-light
    .hero-body
      h1.title.is-5
        span.icon
          i.fas.fa-sitemap.fa-sm.fa-fw
        span
          | 配本管理
  section.section
    <!--button(class="button is-primary is-small" @click="isComponentModalActive = true")-->
    button(class="button is-danger" @click="openNew()")
      b-icon(pack="fas" custom-class="fa-sm fa-plus")
      span
        | 新規作成
  section.section
    .field.is-grouped
      .control
        button(class="button is-small" @click="selectDeliveryType(null)") 一覧
      template(v-for="deliver_type in deliverTypeLinks")
        .control
          button(class="button is-small" @click="selectDeliveryType(deliver_type.id)") {{ deliver_type.name }}
  section.section
    .field
      .control
        button(class="button is-danger" @click="destroy") チェックした行を削除
      <!--| 絞り込む-->
    <!--b-modal(:active.sync="isComponentModalActive" has-modal-card)-->
      <!--search-modal-form(:formProps.sync="formProps" v-on:on-search="onSearch")-->

    div
      b-switch(v-model="allCheckboxSelected" class="table-header-switch" @input="toggleAllCheckboxes" size="is-small" id="check-all")
    b-table(
        :data="data"
        :loading="loading"
        narrowed
        hoverable
        striped
        paginated
        backend-pagination
        :total="total"
        :current-page="page"
        :per-page="perPage"
        @page-change="onPageChange"

        backend-sorting
        :default-sort-direction="defaultSortOrder"
        :default-sort="[sortField, sortOrder]"
        @sort="onSort"
        )
      template(slot-scope="props")
        b-table-column(field="checkbox" label="")
          b-checkbox(v-model="props.row.checked")
        b-table-column(field="sid" label="配本管理ID"  centered)
          a.button.is-rounded.is-info.is-small(@click="onClick(props.row)")
            | {{ props.row.sid }}
        b-table-column(field="book_name" label="書籍名"  sortable )
          | {{ bookName(props.row.isbn) }}
        b-table-column(field="deliver_type_name" label="出荷属性" sortable )
          | {{ deliverTypeName(props.row.deliver_type_id) }}
        b-table-column(field="manipulated_date" label="受注日" )
          | {{ props.row.manipulated_date }}
        b-table-column(field="daily_count" label="日次カウンター" )
          | {{ props.row.daily_count }}
        b-table-column(field="manipulated_order_items_size" label="レコード数" centered)
          | {{ props.row.manipulated_order_items_size }}
        b-table-column(field="user_id" label="作成者" centered)
          | {{ userName(props.row.user_id) }}
</template>

<script>
  // import SearchModalForm from './final_book_shops_search_modal_form'

  export default {
    name: 'manipulated-orders-table',
    data() {
      return {
        data: [],
        total: 0,
        loading: false,
        sortField: 'vote_count',
        sortOrder: 'desc',
        defaultSortOrder: 'desc',
        page: 1,
        perPage: 25,
        isComponentModalActive: false,
        formProps: {
          shop_code_cont: '',
          name_cont: '',
          group_code_cont: '',
          telephone_cont: '',
          prefecture_cont: '',
          delivered_order_id_null: 1,
          s: ''
        },
        default_params: null,
        allCheckboxSelected: false
      }
    },
    // components: { 'search-modal-form': SearchModalForm },
    computed: {
      books(){  return this.$store.getters['Books/records'] },
      deliver_types(){  return this.$store.getters['DeliverTypes/records'] },
      users(){ return this.$store.getters['Users/records'] },
      deliverTypeLinks() {
        let linkNames = ["大村在庫", "日販在庫", "トーハン在庫"]
        return this.deliver_types.filter(type => {
          return linkNames.includes(type.name)
        })
       }
    },
    methods: {
      openNew(){
        window.location.href = `/users/multiple_manipulated_orders/new`
      },
      /*
       * Load async data
       */
      onClick(row){
        window.location.href = `/users/manipulated_orders/${row.id}/edit`
      },
      bookName(value){
        if (!value) return ''
        let a = this.books.filter(book => book.isbn == value)
        return a.length > 0 ? `${a[0].name}: ${a[0].isbn}` : ''
      },
      deliverTypeName(id){
        if (!id) return ''
        let tmp = this.deliver_types
            .filter(type => type.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      userName(id){
        if (!id) return ''
        let tmp = this.users
            .filter(user => user.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      loadAsyncData() {
        const params = '?' + [
          `page=${this.page}`,
          `per_page=${this.perPage}`,
          Object.keys(this.formProps).map((key) => {
            return `q[${key}]=${this.formProps[key]}`
          }).join('&')
        ].join('&')

        this.loading = true
        this.$http.get(`/api/v1/manipulated_orders${params}`)
            .then(({data}) => {
              this.data = []
              this.total = this.totalRows(data.total_results)

              data.manipulated_orders.forEach((item) => {
                item.checked = false
                this.data.push(item)
              })
              this.loading = false
              if(this.default_params != params)
                history.pushState(null, null, `/users/manipulated_orders${params}`)
              else
                history.pushState(null, null, `/users/manipulated_orders`)
            })
            .catch((error) => {
              this.data = []
              this.total = 0
              this.loading = false
              throw error
            })
      },
      onSearch(){
        this.onPageChange(1)
      },
      /*
       * Handle page-change event
       */
      onPageChange(page) {
        this.page = page
        this.loadAsyncData()
      },
      /*
       * Handle sort event
       */
      onSort(field, order) {
        this.page = 1
        this.sortField = field
        this.sortOrder = order
        this.formProps.s = `${this.sortField} ${this.sortOrder}`
        this.loadAsyncData()
      },
      onClick(row){
        window.location.href = `/users/manipulated_orders/${row.id}/edit`
      },
      changeLinkVisibility(event, visibility) {
        event.target.style.visibility = visibility
      },
      selectDeliveryType(deliverTypeId) {
        this.allCheckboxSelected = false
        this.toggleAllCheckboxes()
        this.formProps.deliver_type_id_eq = deliverTypeId ? deliverTypeId : ''
        this.onPageChange(1)
      },
      totalRows(current_total) {
        if (current_total / this.perPage > 1000) {
          current_total = this.perPage * 1000
        }
        return current_total
      },
      toggleAllCheckboxes() {
        this.data.forEach(d => {
          d.checked = this.allCheckboxSelected
        })
      },
      destroy() {
        if(!confirm('本当に削除してもよろしいですか？')) return
        const url = '/api/v1/manipulated_orders.json'
        const selectedManipulatedOrders = this.data.filter(manipulated_order => manipulated_order.checked == true)
        if(selectedManipulatedOrders.length == 0) {
          this.$toast.open({
            message: '削除対象を選択してください。',
            type: 'is-danger',
            position: 'is-bottom'
          })
          return
        }
        const params = {
          manipulated_order_ids: selectedManipulatedOrders.map(order => order.id)
        }
        this.loading = true
        this.$http.delete(url, { data: params }).then(data => {
          this.loading = false
          this.$toast.open({
            message: '削除に成功しました',
            type: 'is-danger',
            position: 'is-bottom'
          })
          this.loadAsyncData()
          this.allCheckboxSelected = false
        })
        .catch(error => {
          this.loading = false
          this.$toast.open({
              message: '削除に失敗しました。',
              type: 'is-danger',
              position: 'is-bottom'
            })
            throw error
        })
      }
    },
    filters: {
      /**
       * Filter to truncate string, accepts a length parameter
       */
      truncate(value, length) {
        return value.length > length
            ? value.substr(0, length) + '...'
            : value
      }
    },
    created(){
      this.default_params = '?' + [
        `page=${this.page}`,
        `per_page=${this.perPage}`,
        Object.keys(this.formProps).map((key) => {
          return `q[${key}]=${this.formProps[key]}`
        }).join('&')
      ].join('&')

      this.$store.dispatch('Books/fetch', 'books')
      this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
      this.$store.dispatch('Users/fetch', 'users')
    },
    mounted() {
      let queries = this.$qs.parse(location.search.slice(1))

      if(queries) {
        let q = queries.q
        if(q) {
          Object.keys(this.formProps).forEach((key) => {
                if (q[key]) {
                  this.formProps[key] = `${q[key]}`
                }
              }
          )
        }
        if (queries.page)
          this.page = parseInt(queries.page)
      }
      this.loadAsyncData()
    }
  }
</script>

<style scoped>
.table-header-switch {
  position: relative;
  top: 25px;
  left: 8px;
  font-weight: bold;
}
</style>